import React from 'react';
import PropTypes from 'prop-types';
import GlobalEventListenerRoot from 'ui-components/components/global-event-listener/root';
import IntlProvider from '../intl/intl-provider';
import UnauthenticatedLocaleContextProvider from '../intl/locale-context-provider/unauthenticated-locale-context-provider';

import ModalManagerPortal from '../portals/modal-manager';
import { Provider as PortalProvider } from '../portals/context';
import UnauthedModalPortalContextProvider from '../contexts/modal-context/unauthed-modal-portal';

const AuthPageProvider = ({ children }) => {
  return (
    <GlobalEventListenerRoot>
      <UnauthenticatedLocaleContextProvider>
        <IntlProvider>
          {children}
          <PortalProvider>
            <UnauthedModalPortalContextProvider>
              <ModalManagerPortal />
            </UnauthedModalPortalContextProvider>
          </PortalProvider>
        </IntlProvider>
      </UnauthenticatedLocaleContextProvider>
    </GlobalEventListenerRoot>
  );
};

AuthPageProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default AuthPageProvider;
